<div class="banner-wrapper">
  <div class="banner-container">
    <div class="left-panel">
      <div class="info-container">
        <div class="vertical-line">
          <div class="title">We’re sending your contract to the general contractor.</div>
          <div class="text">
            This usually takes just a moment—while we process it, here’s something you might find useful.
          </div>
        </div>

        <div class="button-container">
          <button
            mat-stroked-button
            data-test="unskippable-ads-skip-button"
            color="primary"
            [disabled]="skipCountdown > 0"
            (click)="navigateToPreviousPage()"
          >
            {{ skipCountdown > 0 ? 'Skip in ' + skipCountdown : 'Skip' }}
          </button>

          <button
            mat-flat-button
            color="primary"
            [disabled]="hasSentEmail"
            (click)="showLearnMoreSnackbar()"
          >
            Send me an email
          </button>
        </div>
      </div>
    </div>
    <div class="banner">
      <div>
        <div class="right-panel">
          <app-vimeo-player
            class="vimeo-player-container"
            data-test="unskippable-ads-video-player"
            [id]="currentVideoId"
            [responsive]="true"
            [mute]="false"
            (loaded)="onVideoLoaded()"
            (videoEnded)="onVideoEnded()"
            (playerError)="navigateToPreviousPage()"
          />
        </div>
      </div>
    </div>
  </div>
</div>
